<template>
  <div>
    <div>
      <b-row>
        <b-col cols="12">
          <h1 class="title mb-6" v-if="profile">
            {{
              $t('profileTitle', {
                name: title
              })
            }}
          </h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" sm="12" lg="8" xl="6">
          <box>
            <div>
              <b-form>
                <b-row v-if="hasHunterRole && hunterBalance">
                  <b-col>
                    <box class="p-4 mb-4 d-flex align-items-center">
                      <svg-icon
                        icon="earnings"
                        class="text-info icon-2-5x mr-auto"
                      />
                      <div class="ml-2">
                        <div class="text-right">
                          <span class="h1 align-middle">{{
                            hunterBalance.totalEarned
                          }}</span>
                        </div>
                        <div class="text-right">
                          <span class="text-lighten small">{{
                            $t('totalEarned')
                          }}</span>
                        </div>
                      </div>
                    </box>
                  </b-col>
                  <b-col>
                    <box class="p-4 mb-4 d-flex align-items-center">
                      <svg-icon
                        icon="wallet"
                        class="text-success icon-2-5x mr-auto"
                      />
                      <div class="ml-2">
                        <div class="text-right">
                          <span
                            class="h1 align-middle position-relative"
                            style="top: 2px"
                          >
                            {{ hunterBalance.balance }}
                          </span>
                        </div>
                        <div class="text-right">
                          <span class="text-lighten small">{{
                            $t('balance')
                          }}</span>
                        </div>
                      </div>
                    </box>
                  </b-col>
                </b-row>
                <b-form-group
                  :label="`${$t('firstName')}:`"
                  label-for="firstName"
                >
                  <b-form-input
                    id="firstName"
                    type="text"
                    required
                    v-model="profile.firstName"
                    :placeholder="`${$t('firstName')}:`"
                    :state="errors.firstName ? false : null"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.firstName }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  :label="`${$t('lastName')}:`"
                  label-for="lastName"
                >
                  <b-form-input
                    id="lastName"
                    type="text"
                    required
                    v-model="profile.lastName"
                    :placeholder="`${$t('lastName')}:`"
                    :state="errors.lastName ? false : null"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.lastName }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group :label="`${$t('email')}:`" label-for="email">
                  <b-form-input
                    id="email"
                    type="text"
                    readonly
                    :value="profile.email"
                    :placeholder="`${$t('email')}:`"
                  />
                </b-form-group>
                <b-form-group :label="`${$t('roles')}:`">
                  <multi-select
                    :btn-label="`${$t('roles')}:`"
                    size="lg"
                    :options="{ multi: true }"
                    v-model="selectedRoles"
                    :select-options="roles"
                  />
                </b-form-group>
                <!-- <b-form-group
                  v-if="hunterBalance.balance"
                  :label="`${$t('hunterBalance')}:`"
                  label-for="hunter-balance"
                >
                  <b-form-input
                    id="hunter-balance"
                    type="text"
                    readonly
                    :value="hunterBalance.balance"
                    placeholder="0"
                  />
                </b-form-group> -->
                <social-profiles
                  v-if="hasHunterRole && profile.socialNetworks"
                  v-model="socialNetworks"
                  class="mt-7"
                  :errors="errors"
                />
                <payment-accounts
                  v-if="hasHunterRole && profile.wallets"
                  v-model="wallets"
                  :errors="errors"
                />
                <b-form-group>
                  <b-form-checkbox v-model="profile.isBanned">
                    {{ $t('ban') }}
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group v-if="profile.isBanned" label-for="banReason">
                  <b-form-input
                    id="banReason"
                    type="text"
                    v-model="profile.banDescription"
                    :placeholder="$t('banReason')"
                  />
                  <div class="d-flex justify-content-end">
                    <button
                      class="mt-4 btn btn-sm btn-primary"
                      @click.prevent="ban"
                    >
                      {{ $t('ban') }}
                    </button>
                  </div>
                </b-form-group>
              </b-form>
              <div class="text-right mt-4">
                <b-button
                  size="lg"
                  variant="primary"
                  @click="updateProfile"
                  style="padding-left: 4rem; padding-right: 4rem;"
                >
                  {{ $t('save') }}
                </b-button>
              </div>
            </div>
          </box>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import * as auth from '@/utils/auth.js';
import isEqual from 'js-isequal';
import cloneDeep from 'clone';
import SocialProfiles from '@/views/SettingsProfile/BountyHunter/components/SocialProfiles.vue';
import PaymentAccounts from '@/views/SettingsProfile/BountyHunter/components/PaymentAccounts.vue';

export default {
  components: {
    SocialProfiles,
    PaymentAccounts
  },

  data() {
    return {
      profile: {},
      title: '',
      errors: {},
      selectedRoles: [],
      oldRoles: [],
      socialNetworks: {},
      wallets: {},
      hunterBalance: null
    };
  },
  computed: {
    isAdmin() {
      return auth.readActiveRole() === 'admin';
    },
    hasHunterRole() {
      return this.profile.roles ? this.profile.roles.includes(1) : false;
    },
    roles() {
      let roles = [];
      this.$config.roles.forEach((val, key) => {
        roles.push({ id: key, name: this.getRoleName(key) });
      });
      if (!this.isAdmin) {
        roles = roles.filter(
          ({ id }) => !this.$config.excludedRoles.includes(id)
        );
      }
      return roles;
    }
  },

  methods: {
    getRoleName(id) {
      return this.prettify(this.$config.roles.get(id));
    },

    prettify(input) {
      if (!input) {
        return '';
      }
      let result = '';
      const words = input.split('-');
      words.forEach(word => {
        result += word.charAt(0).toUpperCase() + word.slice(1) + ' ';
      });

      return result;
    },

    loadHunterBalance() {
      this.$api.bounty
        .get(`/v0/hunters/${this.profile.id}/balance`)
        .then(res => {
          this.hunterBalance = res.data;
        })
        .catch(() => {
          this.$notify('alert', {
            text: this.$t('canNotGetUserBalance'),
            variant: 'danger',
            time: 5000
          });
        });
    },

    updateProfile() {
      if (this.hasHunterRole) {
        this.profile.socialNetworks = this.socialNetworks;

        const wallets = cloneDeep(this.wallets);
        this.profile.phone = wallets.phone;
        delete wallets.phone;
        this.profile.wallets = wallets;
      }

      this.$api.auth.put(`/users/${this.profile.id}`, this.profile).then(
        () => {
          this.$notify('alert', {
            text: this.$t('profileUpdated'),
            variant: 'success'
          });
        },
        e => {
          this.errors = {};

          if (e.response.status === 400) {
            this.errors = e.response.data.error
              ? this.$parseAuthErrors(e.response.data.error.errors)
              : {};
          } else {
            const text = e.response.data.error
              ? e.response.data.error.message
              : this.$t('somethingWentWrong');
            this.$notify('alert', {
              text,
              variant: 'danger',
              time: 5000
            });
          }
        }
      );
    },

    ban() {
      if (!this.profile.banDescription) {
        this.$notify('alert', {
          text: this.$t('userNoBanReason'),
          variant: 'danger',
          time: 5000
        });
        return;
      }

      const data = {
        banDescription: this.profile.banDescription,
        userId: this.profile.id
      };

      this.$api.auth
        .put('/auth/ban', data)
        .then(() => {
          this.$notify('alert', {
            text: this.$t('userBanned'),
            variant: 'success',
            time: 5000
          });
        })
        .catch(e => {
          e.response.data.error &&
            this.$notify('alert', {
              text:
                e.response.data.error.errors[0].message ||
                this.$t('userNotBanned'),
              variant: 'danger',
              time: 5000
            });
        });
    }
  },

  created() {
    this.$api.auth.get(`/users/${this.$route.params.userId}`).then(
      data => {
        this.profile = data;
        this.title = `${this.profile.firstName} ${this.profile.lastName}`;
        this.selectedRoles = this.profile.roles.map(role => ({
          id: role,
          name: this.getRoleName(role)
        }));
        this.oldRoles = this.selectedRoles.map(item => item.id);

        if (this.hasHunterRole) {
          this.socialNetworks = this.profile.socialNetworks;
          this.wallets = this.profile.wallets;
          this.wallets.phone = this.profile.phone ? this.profile.phone : null;
          this.loadHunterBalance();
        }
      },
      e => {
        this.$store.commit('SET_PAGE_FAILURE', e);
      }
    );
  },

  watch: {
    profile: {
      deep: true,
      handler(val) {
        if (!val.isBanned) {
          this.profile.banDescription = '';
        }
      }
    },
    selectedRoles: {
      deep: true,
      handler(val) {
        const userId = this.profile.id;
        const roles = val.map(item => item.id);
        const data = {
          roles,
          userId
        };

        if (!isEqual(this.oldRoles, roles)) {
          this.$api.auth
            .put(`/users/roles/edit/${data.userId}`, data)
            .then(() => {
              this.$notify('alert', {
                text: this.$t('rolesSaved'),
                variant: 'success',
                time: 5000
              });
              this.oldRoles = roles;
            })
            .catch(e => {
              e.response.data.error.message &&
                this.$notify('alert', {
                  text: e.response.data.error.message || "Couldn't save roles",
                  variant: 'danger',
                  time: 5000
                });
            });
        }
      }
    }
  }
};
</script>
